import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

class SortOptions extends React.Component {
  constructor(props) {
    super(props);

    this.handleSort = this.handleSort.bind(this);
  }

  handleSort(event) {
    let sortDirection = event.target.id;
    if (sortDirection === 'DESC') sortDirection = 'ASC';
    else if (sortDirection === 'ASC') sortDirection = 'NOSORT';
    else sortDirection = 'DESC';
    this.props.handleSortChange({
      sort: { sortField: this.props.sortField, sortDirection }
    });
  }

  render() {
    if (
      this.props.sortDirection &&
      this.props.sortDirection.toUpperCase() === 'DESC' &&
      this.props.sortField === this.props.activeSortField
    )
      return (
        <Icon
          id="DESC"
          name="sort down"
          color="grey"
          className="mouseCursorPointer"
          onClick={this.handleSort}
        />
      );
    else if (
      this.props.sortDirection &&
      this.props.sortDirection.toUpperCase() === 'ASC' &&
      this.props.sortField === this.props.activeSortField
    )
      return (
        <Icon
          id="ASC"
          name="sort up"
          color="grey"
          className="mouseCursorPointer"
          onClick={this.handleSort}
        />
      );
    else
      return (
        <Icon
          id="NOSORT"
          name="sort"
          color="grey"
          className="mouseCursorPointer"
          onClick={this.handleSort}
        />
      );
  }
}

SortOptions.propTypes = {
  sortField: PropTypes.string.isRequired,
  activeSortField: PropTypes.string,
  sortDirection: PropTypes.string
};

SortOptions.defaultProps = {
  sortDirection: '',
  activeSortField: ''
};

export default SortOptions;
